var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.667 0.166504H3.33366C1.86699 0.166504 0.666992 1.3665 0.666992 2.83317V26.8332L6.00033 21.4998H24.667C26.1337 21.4998 27.3337 20.2998 27.3337 18.8332V2.83317C27.3337 1.3665 26.1337 0.166504 24.667 0.166504ZM24.667 18.8332H4.93366L3.33366 20.4332V2.83317H24.667V18.8332Z",
    fill: "#4D2481"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.433dd9605baa34ed099533a99f9e2ae6.svg";
export { ForwardRef as ReactComponent };